import { toast } from 'react-hot-toast';

export const isNullOrEmpty = (data) => {
    return (
        data === null ||
        data === undefined ||
        data === '' ||
        (Array.isArray(data) && data.length === 0) ||
        (typeof data === 'object' && Object?.keys(data).length === 0)
    );
};

// export const showToast = (message = '', type = 'info') => {
//     if (isNullOrEmpty(message) || isNullOrEmpty(type) || !type) {
//         return;
//     }
//
//     toast(message, { type, toastId: message });
// };
export const capitalize = (str) => {
  if (!str) return str; // Handle null or undefined strings
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
 

export const showToast = (message,type) => {
  toast.dismiss(); // <-- dismisses any active toasts
  switch (type) {
    case "success":
      toast.success(message);
      break;
    case "error":
      toast.error(message);
      break;
    case "loading":
      toast.loading(message);
      break;
    default:
      toast(message);
  }
};


export function serialize(obj) {
    let str = [];
    for (let p in obj) {
        if (obj.hasOwnProperty(p)) {
            if (Array.isArray(obj[p])) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p].join(',')));
            } else {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        }
    }
    return str.join("&");
}

export const createOptionListForSelectTag = (data = null, label = "", value = "", suffix = "", overrideLabel = "") => {
    let list = [];

    if (isNullOrEmpty(data) || isNullOrEmpty(label) || isNullOrEmpty(value)) {
        return list;
    }

    if (!Array.isArray(data)) {
        return list;
    }

    list = data?.map(cur => {
        const labelText =
            (isNullOrEmpty(overrideLabel) || isNullOrEmpty(cur[overrideLabel]))
                ? cur[label]
                : cur[overrideLabel];

        return {
            value: cur[value],
            label: labelText + (isNullOrEmpty(suffix) ? "" : " (" + cur[suffix] + ")"),
        };
    });

    return list;
};


export const validatePassword = (password, confirmPassword) => {
    const regexForUppercase = new RegExp("(?=.*[A-Z])");
    const regexForLowercase = new RegExp("(?=.*[a-z])");
    const regexForNum = new RegExp(/\d/);
    const regexForSpecialChar = new RegExp("(?=.*\\W)");
    const regexForLength = new RegExp(/^.{12,50}$/);

    let error = {
        isValidSubmission: false,
    };

    if (!regexForUppercase.test(password)) {
        error.uppercaseChar = "Must contain at least one uppercase letter (A - Z)";
    } else {
        error.uppercaseCheck = "true";
    }

    if (!regexForLowercase.test(password)) {
        error.lowercaseChar = "Must contain at least one lowercase letter (a - z)";
    } else {
        error.lowercaseCheck = "true";
    }

    if (!regexForNum.test(password)) {
        error.number = "Must contain at least one number (0 - 9)";
    } else {
        error.numberCheck = "true";
    }

    if (!regexForSpecialChar.test(password)) {
        error.specialChar = "Must contain at least one special character (e.g. !, #, $, %)";
    } else {
        error.specialCharCheck = "true";
    }

    if (!regexForLength.test(password)) {
        error.length = "Must contain between 12 and 50 characters";
    } else {
        error.lengthCheck = "true";
    }

    if (password !== confirmPassword && confirmPassword !== null && confirmPassword !== "") {
        error.match = "Password and Confirm Password don't match!";
    } else {
        error.match = "";
    }

    error.isValidSubmission =
        regexForUppercase.test(password) &&
        regexForLowercase.test(password) &&
        regexForNum.test(password) &&
        regexForSpecialChar.test(password) &&
        regexForLength.test(password);

    if (error.isValidSubmission) {
        delete error.uppercaseChar;
        delete error.lowercaseChar;
        delete error.number;
        delete error.specialChar;
        delete error.length;
    }

    return error;
};

export const getClassByType = (type) => {
  const classMap = {
    pending: 'class-pending',
    ontheway: 'class-ontheway',
    started: 'class-started',
    completed: 'class-completed',
    rejected: 'class-rejected',
  };

  return classMap[type?.toLowerCase()] || 'default-class';
};

export const formatDateToMDY = (dateString) => {
  if (!dateString) return '';

  const date = new Date(dateString);
  const month = date.getUTCMonth() + 1; // months are 0-based
  const day = date.getUTCDate();
  const year = date.getUTCFullYear();

  return `${day}/${month}/${year}`;
};

export const formatTimeTo12Hour = (timeString) => {
  if (!timeString) return '';

  const [hourStr, minuteStr] = timeString.split(':');
  let hour = parseInt(hourStr, 10);
  const minute = parseInt(minuteStr, 10);

  const period = hour >= 12 ? 'PM' : 'AM';
  hour = hour % 12 || 12; // convert 0 -> 12

  return `${hour}:${minute.toString().padStart(2, '0')} ${period}`;
};

export const formatDateTimeToUK = (dateString) => {
  if (!dateString) return '';

  const date = new Date(dateString);
  
  // Format date part (M/D/YYYY)
  const dateFormatted = date.toLocaleDateString('en-GB', {
    timeZone: 'Europe/London',
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
  });

  // Format time part (12-hour with AM/PM)
  const timeFormatted = date.toLocaleTimeString('en-GB', {
    timeZone: 'Europe/London',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });

  return `${dateFormatted} ${timeFormatted}`;
};


export const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
};


export const fetchSnappedLocation = async (lat, lng) => {
  const path = `${lat},${lng}`;
  const response = await fetch(
    `https://roads.googleapis.com/v1/snapToRoads?path=${path}&interpolate=false&key=${process.env.REACT_APP_GOOGLE_MAP_API_KEY}`
  );
  const data = await response.json();
  if (data.snappedPoints && data.snappedPoints.length > 0) {
    return {
      lat: data.snappedPoints[0].location.latitude,
      lng: data.snappedPoints[0].location.longitude,
    };
  }
  return { lat, lng };
}; 

export function getQuestionLabel(type) {
  const typeData = {
    text: {
      label: "Single Line Text Box",
      image: "/images/text.png", // your image path
    },
    number: {
      label: "Numerical Value",
      image: "/images/number.png",
    },
    multiSelect: {
      label: "Multiple choice: multiple answers allowed",
      image: "/images/multiple.png",
    },
    singleSelect: {
      label: "Multiple choice: only one answer",
      image: "/images/multiple.png",
    },
    boolean: {
      label: "Yes / No",
      image: "/images/boolean.png",
    },
    date: {
      label: "Datetime",
      image: "/images/date.png",
    },
    range: {
      label: "Range (1-10)",
      image: "/images/range.png",
    },
    image: {
      label: "Image",
      image: "/images/range.png",
    },
    video: {
      label: "Video",
      image: "/images/range.png",
    },
  };

  return typeData[type] || {
    label: "Unknown",
    image: "/images/video.png",
  };
}

export const getStatusClass = (status) => {
  switch (status) {
    case "submitted":
      return "status-submitted";
    case "assigned":
      return "status-assigned";
    case "in_progress":
      return "status-in_progress";
    default:
      return "";
  }
};